import type { Project } from '../types/project';
import type { Role, User } from '../types/user';
import { ROLE_PERMISSIONS, type Permission } from './permissions';

export function roleHas(role: Role, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}

export function can(user: Pick<User, 'role' | 'status'> | null | undefined, permission: Permission): boolean {
  if (!user || user.status !== 'ACTIVE') return false;
  return roleHas(user.role, permission);
}

export function canAny(
  user: Pick<User, 'role' | 'status'> | null | undefined,
  permissions: Permission[],
): boolean {
  return permissions.some((permission) => can(user, permission));
}

/** Projeto concluído entra em modo somente leitura (PRJ-090 / PRJ-093). */
export function isProjectReadOnly(project: Pick<Project, 'status'> | null | undefined): boolean {
  return project?.status === 'COMPLETED';
}

/** Projeto pendente bloqueia tarefas, alocação e apontamento (PRJ-040 / PRJ-041). */
export function isProjectBlocked(project: Pick<Project, 'status'> | null | undefined): boolean {
  return project?.status === 'PENDING_ADMIN_APPROVAL' || project?.status === 'PENDING_CONFIGURATION';
}

/** Regra combinada: permissão + estado do projeto. */
export function canMutateProject(
  user: Pick<User, 'role' | 'status'> | null | undefined,
  project: Pick<Project, 'status'> | null | undefined,
  permission: Permission,
): boolean {
  if (isProjectReadOnly(project) || isProjectBlocked(project)) return false;
  return can(user, permission);
}

export function isGlobalAdministratorRole(role: Role | null | undefined): boolean {
  return role === 'ADMIN' || role === 'SUPER_ADMIN';
}

/** Custo hora em claro — exclusivo de SUPER_ADMIN (ORG-03-R02). */
export function canManageHourlyCost(user: Pick<User, 'role'> | null | undefined): boolean {
  return user?.role === 'SUPER_ADMIN';
}
